import DataApi from "./DataApi";

const WorkflowApi = {
  async saveWorkflow(workflow) {
    console.log("Workflow: ", workflow);

    try {
      const dataApi = new DataApi("workflows");
      const response = await dataApi.create(workflow);
      return response.data;
    } catch (error) {
      console.error("Error saving workflow:", error);

      // Extract error message from axios error response
      const errorMessage =
        error.response?.data?.errors?.[0]?.msg ||
        error.response?.data?.message ||
        error.message ||
        "Failed to save workflow";

      const customError = new Error(errorMessage);
      customError.status = error.response?.status;
      customError.details = error.response?.data;
      throw customError;
    }
  },

  async fetchWorkflows(id = null) {
    try {
      const dataApi = new DataApi("workflows");

      if (id) {
        const response = await dataApi.fetchById(id);
        return response.data;
      } else {
        const response = await dataApi.fetchAll();
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching workflows", error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch workflows";

      throw new Error(errorMessage);
    }
  },

  async deleteWorkflow(workflowId) {
    if (!workflowId) {
      throw new Error("Workflow ID is required for deletion.");
    }

    try {
      const dataApi = new DataApi("workflows");
      const response = await dataApi.delete(workflowId);
      return response.data;
    } catch (error) {
      console.error("Error deleting workflow", error);

      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to delete workflow";

      throw new Error(errorMessage);
    }
  },
};

export default WorkflowApi;
